import React, { useLayoutEffect, useImperativeHandle, FC } from 'react';
import { useSelector } from 'react-redux';

import { useI18n } from 'i18n';
import Loader from 'core/react/general/Loader';
import { RunwayStatusTile } from './runway-status-tile';
import { widgetsSelector } from 'core/redux/selectors/widgets';
import { runwaysStatusesSelector } from 'core/redux/selectors/runways';
import WidgetErrorContent from 'core/react/general/widgets/WidgetErrorContent';
import { runwaysSelector } from 'core/redux/selectors/registry';

interface IRunwayStatusesProps {
  uid: string;
  reduxKey: string;
  expanded: boolean;
  customRef: React.RefObject<any>;
  update(): void;
}

export const RunwayStatusesWidget: FC<IRunwayStatusesProps> = (props) => {
  const { fc } = useI18n();

  const widgets = useSelector(widgetsSelector);
  const runwaysStatuses = useSelector(runwaysStatusesSelector);
  const runways = useSelector(runwaysSelector);

  const widgetData = widgets[props.reduxKey].map[props.uid]?.data;
  const { pending, list, error } = runwaysStatuses;

  useLayoutEffect(() => {
    props.update();
  }, [widgetData]);

  useImperativeHandle(props.customRef, () => ({
    title: () => fc('Runway statuses'),
    expandable: true,
  }));

  if (pending) {
    return (
      <div className="widget-error">
        <Loader />
      </div>
    );
  }

  if (list?.length) {
    return (
      <div>
        {list
          .sort((a, b) => a.runwayId - b.runwayId)
          .map((statusInfo, index) => (
            <RunwayStatusTile key={index} statusInfo={statusInfo} runway={runways.map?.[statusInfo.runwayId] || null} />
          ))}
      </div>
    );
  }

  return <WidgetErrorContent message={fc('no info found')} />;
};
